class GiftWrapOption extends HTMLElement {
  connectedCallback() {
    const checkbox = this.querySelector('[data-gift-wrap-toggle]');
    if (!checkbox || checkbox.dataset.bound === 'true') return;

    checkbox.dataset.bound = 'true';
    checkbox.addEventListener('change', () => {
      this.save(checkbox.checked ? 'si' : 'no');
    });
  }

  save(value) {
    if (!window.theme?.routes?.cart_update_url || typeof fetchConfig !== 'function') return;

    fetch(theme.routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify({ attributes: { para_regalo: value } })
    }).catch((error) => console.error(error));
  }
}

if (!customElements.get('gift-wrap-option')) {
  customElements.define('gift-wrap-option', GiftWrapOption);
}
